import React, { Component } from 'react';
import { Table } from "react-bootstrap";

import { INGRESOS, EGRESOS } from "../../shared/IngresosEgresos";

import BecaFamilia3Table from "./BecaFamilia3Table";

class BecaFamilia3 extends Component {
    state = {
        datosInfoIn: this.props.datos.infoIn.value,
        datosInfoOut: this.props.datos.infoOut.value,
    }

    updaState = (campo, valor, tipo) => {
        
        let upd = (datos, datosM) => {
            let control = false
            let n = 0

            let contenido = this.state[datos];

            for (let i in contenido) {
                if (contenido[i][campo] !== undefined){ control = true; n = i } 
            }

            (control === false) ? contenido.push({[campo]: valor}) : contenido[n][campo] = valor;
            this.setState({[datos]: contenido})

            let camp = { value: contenido, errMess: "" }
            this.props.funcion(datosM, camp, "datosBecaFamilia3")
        }

        (tipo === "in") ? upd("datosInfoIn", "infoIn") : upd("datosInfoOut", "infoOut");
    }

    render() {
        let  { datosInfoIn, datosInfoOut } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        let total = (state) => {
            let total = 0
            for (let i in state) {
                let key = Object.keys(state[i])[0];
                total += parseInt(state[i][key])
            }
            
            return `${total} Bs`
        }

        let contenido = () => {
            return (
                INGRESOS.map(option => (
                    <BecaFamilia3Table key={option.id} datos={option} egreso ={EGRESOS[option.id]}
                    funcion = {(campo, valor, tipo) => {this.updaState(campo, valor, tipo)}}/>
                ))
            )
        }
        
        return (
            <div style={{paddingRight: 10, paddingLeft: 20}}>
                <div className="custom-alert-warning custom-mt-10">Familia</div>
                <div className="table-responsive custom-mt-10" style={{backgroundColor:"#FFF"}}>
                    <Table striped hover bordered>
                        <tbody>
                            <tr className="custon-back-color-warning">
                                <td align="center" colSpan={2} width="40%" style={styles}><strong>Ingresos del grupo familiar</strong></td>
                                <td align="center" colSpan={2} width="40%" style={styles}><strong>Egresos del grupo familiar</strong></td>
                                <td align="center" width="20%" style={styles}><strong>Gastos o egresos propios</strong></td>
                            </tr>
                            {contenido()}
                            <tr className="custon-back-color-warning">
                                <td style={styles} align="right"><strong>Total de Ingresos en Bs.</strong></td>
                                <td style={styles} width="100px"><strong>{total(datosInfoIn)}</strong></td>
                                <td style={styles} align="right"><strong>Total de Egresos en Bs.</strong></td>
                                <td style={styles} width="100px"></td>
                                <td align="center" style={styles}><strong>{total(datosInfoOut)}</strong></td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </div>
        );
    }
}
 
export default BecaFamilia3;


// WEBPACK FOOTER //
// ./src/views/EstSolicitudes/BecaFamilia3.jsx